// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
export const getStronglyTypedEntries = Object.entries as <T extends object>(
  obj: T,
) => [[keyof T, T[keyof T]]];
